//@ 手機號碼
export const validateTaiwanMobile = (phone: string): boolean => {
  const mobileRegex = /^09\d{8}$/;
  return mobileRegex.test(phone);
};

//@ 市話 (含區碼)
/* 規則：
 * 1. 區碼為 2-3 碼 (02, 03, 037, 04, 042...)
 * 2. 總長度為 9-10 碼 (含 0)
 * 3. 排除 09 開頭
 */
export const validateTaiwanLandline = (phone: string): boolean => {
  if (phone.startsWith("09")) return false;
  const landlineRegex = /^0\d{1,2}\d{7,8}$/;
  return landlineRegex.test(phone);
};

//@ 同時驗證手機及市話
export const validateTaiwanPhone = (phone: string): boolean => {
  if (!phone) return true;
  const cleanPhone = phone.replace(/[-()\s]/g, "");
  return validateTaiwanMobile(cleanPhone) || validateTaiwanLandline(cleanPhone);
};
